import "@arco-design/web-react/es/Tooltip/style";
import _Tooltip from "@arco-design/web-react/es/Tooltip";
import "@arco-design/web-react/es/Button/style";
import _Button from "@arco-design/web-react/es/Button";
import _IconSunFill from "@arco-design/web-react/icon/react-icon/IconSunFill";
import _IconMoonFill from "@arco-design/web-react/icon/react-icon/IconMoonFill";
import React from 'react';
import { useTheme } from '@/hooks/useTheme';
export function ThemeButton() {
  const {
    theme,
    setTheme
  } = useTheme();
  return /*#__PURE__*/React.createElement(_Tooltip, {
    content: theme === 'light' ? '点击切换为暗黑模式' : '点击切换为亮色模式'
  }, /*#__PURE__*/React.createElement(_Button, {
    icon: theme !== 'dark' ? /*#__PURE__*/React.createElement(_IconMoonFill, null) : /*#__PURE__*/React.createElement(_IconSunFill, null),
    shape: "circle",
    type: "secondary",
    onClick: () => setTheme(theme === 'light' ? 'dark' : 'light')
  }));
}